import type { FrameOrderAggregateStats } from '../../types/frameOrders';

interface FrameOrderStatsProps {
    stats: FrameOrderAggregateStats;
    total: number;
    activeClassification?: string;
    onClassificationClick: (classification: string) => void;
}

export function FrameOrderStats({ stats, total, activeClassification, onClassificationClick }: FrameOrderStatsProps) {
    const infoStats = [
        { label: 'Total Orders', value: total.toLocaleString(), color: 'text-gray-900' },
        { label: 'Outstanding Qty', value: Math.round(stats.totalOutstandingQty).toLocaleString(), color: 'text-blue-600' },
    ];

    const classificationStats = [
        { label: 'Green', value: stats.greenCount, color: 'text-green-600', ringColor: 'ring-green-400', bgActive: 'bg-green-50' },
        { label: 'Yellow', value: stats.yellowCount, color: 'text-yellow-600', ringColor: 'ring-yellow-400', bgActive: 'bg-yellow-50' },
        { label: 'Red', value: stats.redCount, color: 'text-red-600', ringColor: 'ring-red-400', bgActive: 'bg-red-50' },
        { label: 'Unknown', value: stats.unknownCount, color: 'text-gray-500', ringColor: 'ring-gray-400', bgActive: 'bg-gray-100' },
    ];

    return (
        <>
            {infoStats.map(stat => (
                <div key={stat.label} className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                    <p className="text-xs font-medium text-gray-500">{stat.label}</p>
                    <p className={`mt-1 text-xl font-semibold ${stat.color}`}>{stat.value}</p>
                </div>
            ))}
            {classificationStats.map(stat => {
                const isActive = activeClassification === stat.label;
                return (
                    <button
                        key={stat.label}
                        onClick={() => onClassificationClick(stat.label)}
                        className={`rounded-lg border px-4 py-3 text-left transition-all hover:shadow-sm ${
                            isActive
                                ? `${stat.bgActive} border-transparent ring-2 ${stat.ringColor}`
                                : 'border-gray-200 bg-white hover:border-gray-300'
                        }`}
                    >
                        <p className="text-xs font-medium text-gray-500">{stat.label}</p>
                        <p className={`mt-1 text-xl font-semibold ${stat.color}`}>{stat.value.toLocaleString()}</p>
                    </button>
                );
            })}
        </>
    );
}
